import { render, staticRenderFns } from "./BodyPart.vue?vue&type=template&id=c149fa9e"
import script from "./BodyPart.vue?vue&type=script&lang=js"
export * from "./BodyPart.vue?vue&type=script&lang=js"
import style0 from "./BodyPart.vue?vue&type=style&index=0&id=c149fa9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports